import { Routes } from '@angular/router';
import { PaylasimSistemiComponent } from './paylasim-sistemi.component';
import { uyeOlmayanGiremezGuard } from '../../guards/uye.guard';
import { uygulamaErisimGuard } from '../../guards/uygulama-erisim.guard';

// Eski sistem deseni: login zorunlu + uygulama erişim izni kontrolü.
export const PAYLASIM_SISTEMI_ROUTES: Routes = [
  {
    path: '',
    title: 'FikoYT | Paylaşım',
    component: PaylasimSistemiComponent,
    canActivate: [uyeOlmayanGiremezGuard, uygulamaErisimGuard],
    // Eski sistemde main.ts side-effect import'lari ile kaydolan dinamik bilesenler
    // (kart/alt-kart renderer'lari) MFE'de hicbir yerde yuklenmiyordu -> DinamikBilesenRegistry bos.
    // @shared icinden (ayni registry singleton'i) dinamik import edilir; kayitlar
    // component olusmadan once tamamlanir.
    resolve: { dinamikKayitlar: () => import('./dinamik-kayitlar').then(() => true) },
    data: { preload: true, animasyonTag: "📢", baslik: "Paylaşım Sistemi", simge: "📢" },
  },
];
